import React, { useState, useEffect, useReducer, useRef } from "react";
import Button from "../button/button";
import { uploadAudio } from "../../services/transcript.service";
import ModalAudios from "./modalAudios";
import ListTranscript from "./list_transcript";
import ComponentSpeakToTeach from "./componentSpeakToTeach";

const uploadReducer = (state, action) => {
  switch (action.type) {
    case "START_UPLOAD":
      return {
        ...state,
        uploading: true,
        uploadProgress: 0,
        uploadSuccess: false,
        errorMessage: "",
        successMessageFinal: "",
      };
    case "UPDATE_PROGRESS":
      return { ...state, uploadProgress: action.payload };
    case "UPLOAD_SUCCESS":
      return {
        ...state,
        uploading: false,
        uploadSuccess: true,
        audioFile: null,
        successMessageFinal: "Archivo subido con éxito",
      };
    case "UPLOAD_FAILURE":
      return { ...state, uploading: false, errorMessage: action.payload };
    case "SET_AUDIO_FILE":
      return { ...state, audioFile: action.payload };
    case "SET_CUSTOM_NAME":
      return { ...state, customName: action.payload, errorMessage: "" };
    case "RESET_FILE":
      return { ...state, audioFile: null };
    case "SET_TYPE_AUDIO":
      return { ...state, typeAudio: action.payload };
    case "SET_SUCCESS_MESSAGE":
      return { ...state, successMessageFinal: "" };
    default:
      return state;
  }
};

const initialState = {
  audioFile: null,
  uploading: false,
  uploadProgress: 0,
  uploadSuccess: false,
  errorMessage: "",
  customName: "",
  successMessageFinal: "",
  typeAudio: "",
};

const UploadAudio = () => {
  const [state, dispatch] = useReducer(uploadReducer, initialState);
  const {
    audioFile,
    uploading,
    uploadProgress,
    uploadSuccess,
    errorMessage,
    customName,
    successMessageFinal,
    typeAudio,
  } = state;

  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const fileInputRef = useRef(null);

  const userData = JSON.parse(localStorage.getItem("user"));

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenSpeakToTeach, setIsOpenSpeakToTeach] = useState(false);

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleModalSpeakToTeach = () => {
    setIsOpenSpeakToTeach(!isOpenSpeakToTeach);
  };

  const resetFileInput = () => {
    dispatch({ type: "RESET_FILE" });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    return () => {
      if (mediaRecorder && mediaRecorder.state !== "inactive") {
        mediaRecorder.stop();
      }
    };
  }, [mediaRecorder]);

  const handleFileSelect = (event) => {
    dispatch({ type: "SET_SUCCESS_MESSAGE" });
    const file = event.target.files[0];
    if (file) {
      dispatch({ type: "SET_AUDIO_FILE", payload: file });
      dispatch({ type: "SET_TYPE_AUDIO", payload: "Archivo guardado" });
    }
  };

  const startRecording = async () => {
    dispatch({ type: "RESET_FILE" });
    dispatch({ type: "SET_SUCCESS_MESSAGE" });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        const recorder = new MediaRecorder(stream);
        let chunks = [];

        recorder.ondataavailable = (e) => {
          chunks.push(e.data);
        };

        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: "audio/mp3" });
          const audioFile = new File([blob], "audio_recording.mp3", {
            type: "audio/mp3",
          });
          dispatch({ type: "SET_AUDIO_FILE", payload: audioFile });
          dispatch({ type: "SET_TYPE_AUDIO", payload: "Grabación guardada" });
        };

        recorder.start();
        setMediaRecorder(recorder);
        setIsRecording(true);
      } catch (err) {
        console.error("Error al acceder al micrófono", err);
      }
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      setIsRecording(false);
    }
  };

  const handleCustomNameChange = (event) => {
    dispatch({ type: "SET_SUCCESS_MESSAGE" });
    dispatch({ type: "SET_CUSTOM_NAME", payload: event.target.value });
  };

  const handleUpload = () => {
    dispatch({ type: "SET_SUCCESS_MESSAGE" });
    if (!audioFile) return;

    if (!customName.trim() || customName.includes(" ")) {
      dispatch({
        type: "UPLOAD_FAILURE",
        payload: "Por favor ingrese un nombre para el archivo sin espacios.",
      });
      return;
    }

    dispatch({ type: "START_UPLOAD" });

    if (!userData) {
      return { error: "No se encontraron datos del Usuario" };
    }

    uploadAudio(userData, audioFile, customName, dispatch);
    resetFileInput();
  };

  return (
    <div className="max-w-3xl mx-auto p-6 bg-[#28345C] rounded-lg shadow-lg border border-gray-800">
      <div className="mb-4 flex justify-center gap-6">
        <input
          type="file"
          accept="audio/*"
          onChange={handleFileSelect}
          disabled={uploading || isRecording}
          ref={fileInputRef}
          className="w-auto text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-md text-white"
        />
        <div>
          {!isRecording ? (
            <Button
              onClick={startRecording}
              disabled={uploading}
              variant={"primary"}
              label={"Iniciar Grabación"}
            />
          ) : (
            <Button
              onClick={stopRecording}
              disabled={uploading}
              label={"Detener Grabación"}
              variant={"red-button"}
            />
          )}
        </div>
      </div>

      {audioFile && !isRecording && (
        <div className="mb-4 text-green-500 text-white text-center">
          <p>{`${typeAudio} con éxito, dale un nombre a este archivo`}</p>
        </div>
      )}

      <div className="w-full mx-auto flex justify-center mb-4">
        <input
          type="text"
          placeholder="Ingresa un nombre personalizado para el archivo"
          value={customName}
          onChange={handleCustomNameChange}
          disabled={uploading || isRecording}
          className="w-[80%] p-3 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
        />
      </div>

      <div className="w-full flex justify-center mt-8">
        <Button
          label={uploading ? "Subiendo..." : "Subir Audio"}
          variant={"primary"}
          onClick={handleUpload}
          disabled={uploading || !audioFile || !customName.trim()}
        />
      </div>

      {errorMessage && (
        <div className="flex justify-center w-full mt-4">
          <p className="text-white">{errorMessage}</p>
        </div>
      )}

      {uploading && (
        <div className="mt-4">
          <p className="text-center text-sm text-white">
            Progreso: {uploadProgress}%
          </p>
          <progress
            value={uploadProgress}
            max="100"
            className="w-full h-2 [&::-webkit-progress-bar]:rounded-lg [&::-webkit-progress-value]:rounded-lg [&::-webkit-progress-bar]:bg-slate-300 [&::-webkit-progress-value]:bg-white [&::-moz-progress-bar]:bg-white"
          />
        </div>
      )}

      {uploadSuccess && (
        <div className="mt-4">
          <p className="text-center text-white font-semibold">
            {successMessageFinal}
          </p>
        </div>
      )}
      <div className="w-full flex justify-center mt-5 gap-5">
        <Button
          label={"Ver Transcripciones"}
          variant={"primary"}
          onClick={handleModal}
        />
        <Button
          label={"Conversión en vivo"}
          variant={"primary"}
          onClick={handleModalSpeakToTeach}
        />
      </div>
      <ModalAudios
        isOpen={isOpen}
        onClose={handleModal}
        children={<ListTranscript id={userData.id} />}
      />
      <ModalAudios
        isOpen={isOpenSpeakToTeach}
        onClose={handleModalSpeakToTeach}
        children={<ComponentSpeakToTeach isOpenSpeakToTeach={isOpenSpeakToTeach} />}
      />
    </div>
  );
};

export default UploadAudio;
